/**
 * @desc 导入采购调价申请单
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: string, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/importProcurement`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
